import React, { useEffect, useState } from "react";
import Images from "../asset/Images";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import { branchData } from "../globalApi/GlobalApi";
import visibilityoff from "../asset/visibility_off.png";
import visibilityon from "../asset/visibility_on.png";
import axios from "axios";
const Login = () => {
  const { handleSubmit, control } = useForm();
  const navigate = useNavigate();
  const [isShow, setIsShow] = useState(true);
  const [error, setError] = useState();

  // POST API START
  const { mutate, isLoading: postLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/register/login`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error; // Rethrow to trigger onError
      }
    },
    {
      onSuccess: (data) => {
        sessionStorage.setItem("login", true);
        const {
          companyName,
          no,
          street,
          locality,
          city,
          pincode,
          phoneNumber,
          alternativeNumber,
          gstIn,
        } = data;

        const billDetails = {
          name: companyName || "",
          no: no || "",
          street: street || "",
          locality: locality || "",
          city: city || "",
          pincode: pincode || "",
          phoneNumber: phoneNumber || "",
          alternativeNumber: alternativeNumber || "",
          gstIn: gstIn || "",
        };

        sessionStorage.setItem("billDetails", JSON.stringify(billDetails));
        sessionStorage.setItem("companyName", companyName);
        sessionStorage.setItem("registerDetails", JSON.stringify(data));
        // sessionStorage.setItem("phoneNumber", phoneNumber);

        // window.location.reload();
        navigate("/");
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to login. Please try again.");
      },
    }
  );

  // GET API START
  const { data, isLoading, isError, refetch } = useQuery("data", branchData, {
    refetchOnWindowFocus: false, // Disable refetch on window focus
  });

  let details = (data && data?.data) || [];

  let branchArray = details?.map((data) => {
    return data?.branchName;
  });

  useEffect(() => {
    if (branchArray?.length > 0) {
      sessionStorage.setItem("branchNames", JSON.stringify(branchArray));
    }
  }, [branchArray]);

  const onSubmit = (data) => {
    let formData = {
      emailId: data?.emailId,
      newPassword: data?.password,
    };
    if (formData) {
      mutate(formData);
    }
  };
  return (
    <>
      <section className="loginMainSection">
        <div className="login_main_block">
          <div className="login_heading_block my-3">
            <div className="login_image_block">
              <img src={Images?.logo} alt="no-image" className="image_icon" />
            </div>
            <h5 className="login_heading">2K Inventry</h5>
          </div>
          <form className="my-3" onSubmit={handleSubmit(onSubmit)}>
            <div className="login_input_block">
              <label className="login_label">Username</label>
              <Controller
                name="emailId"
                control={control}
                render={({ field }) => (
                  <input
                    type="email"
                    {...field}
                    className="login_input_field"
                  />
                )}
              />
            </div>
            <div className="login_input_block">
              <label className="login_label">Password</label>
              <div className="loginPasswordBlock">
                <Controller
                  name="password"
                  control={control}
                  render={({ field }) => (
                    <input
                      type={`${!isShow ? "text" : "password"}`}
                      {...field}
                      className="login_password_field"
                    />
                  )}
                />
                <div
                  className="passwordBlock"
                  onClick={() => {
                    setIsShow(!isShow);
                  }}
                >
                  {!isShow ? (
                    <img
                      src={visibilityon}
                      style={{ width: "100%", height: "100%" }}
                      alt="no-image"
                    />
                  ) : (
                    <img
                      src={visibilityoff}
                      style={{ width: "100%", height: "100%" }}
                      alt="no-image"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="loginInputFieldBlock m-0 p-0">
              {isError && (
                <p
                  style={{ color: "red", fontWeight: "500" }}
                  className="p-0 m-0"
                >
                  {error &&
                    error?.response &&
                    error?.response?.data &&
                    error?.response?.data?.message}
                </p>
              )}
            </div>

            <div className="login_input_block my-4">
              <button className="login_btn">
                {postLoading ? (
                  <>
                    {" "}
                    <i class="fa fa-circle-o-notch fa-spin"></i>
                  </>
                ) : (
                  <>Sign In</>
                )}
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default Login;
